import { Component } from 'react'
import gql from 'graphql-tag'
import { graphql } from '@apollo/client/react/hoc'
import { Alert, Progress, Nav, NavItem, NavLink, TabContent, TabPane, UncontrolledTooltip } from 'reactstrap'

import './Incidents.css'
import IncidentDetailHeader from './IncidentDetailHeader'
import OverviewTab from './OverviewTab/OverviewTab'
import IncidentDocumentsTab from './DocumentsTab/IncidentDocumentsTab'
import PartiesTabContainer from './PartiesTab/PartiesTabContainer'
import ClaimsTab from './ClaimsTab/ClaimsTab'
import InspectionTab from './InspectionTab/InspectionTab'
import { HasPermissionsQuery } from '../Functions/querys'
import withApolloClient from '../withApolloClient'
import DashcamTab from './DashcamTab'
import HistoryList from '../Material/HistoryList'
import TasksTab from './TasksTab/TasksTab'
import RelatedIncidentsTab from './RelatedIncidentsTab'
import { getTaskIdFromHash, normalizeTaskTabHash } from "../TaskManagement/taskNavigation"

const IncidentDetailQuery = gql`query Incident($incidentId: ID!){
    incident(incidentId:$incidentId){
        id
        pk
        dateAdded
        incidentDate
        location
        dataProgress
        status
        carOnHold
        isArchived
        title
        metadata
        isRecordOnly
        missingDataFields
        openTaskCount
        unarchivedRelatedIncidentCount
        vinRelatedIncidentCount
        subroClaimExists
        driver{
            id
            name
            hasPendingInsurance
            hasIncompleteReturn
        }
        taskSet(isArchived:false){
            edges{
                node{
                    id
                    status
                }
            }
        }
        branch{
            id
            name
        }
        damageTransaction {
            id
        }
        incidentdamageSet {
            edges {
                node {
                    id
                }
            }
        }
        carCondition{
            id
        }
        rental{
            id
        }
        car{
            id
            pk
            year
            vin
            carModel{
                id
                name
                make
            }
        }
        liabilityclaimSet(isArchived: false) {
          edges {
            node {
              id
              dateAdded
              externalId
            }
          }
        }
        incidentdocumentSet(isArchived: false) {
            edges {
                node {
                    id
                }
            }
        }
        incidentpartySet(isArchived:false){
            edges{
                node{
                    id
                    isDefault
                    partyType
                    vehicles{
                        edges{
                            node{
                                id
                                vin
                            }
                        }
                    }
                    incidentpartypeopleSet(isArchived:false){
                        edges{
                            node{
                                id
                                name
                                role
                            }
                        }
                    }
                }
            }
        }
    }
}`

const INCIDENT_DETAIL_PAGE_TABS = [
    { id: "#overview", name: "OVERVIEW" },
    { id: "#inspection", name: "INSPECTION" },
    { id: "#parties", name: "PARTIES" },
    { id: "#claims", name: "CLAIMS" },
    { id: "#documents", name: "DOCUMENTS" },
    { id: "#dashcam", name: "DASHCAM" },
    { id: "#tasks", name: "TASKS" },
    { id: "#related", name: "RELATED/DUPLICATE" },
    { id: "#history", name: "HISTORY" },
]
class IncidentDetailContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: "",
        }
    }

    toggleTab = (tabId) => {
        this.props.navigate({ hash: tabId })
        this.setState({ tab: tabId })
    }

    componentDidMount() {
        let defaultTab = INCIDENT_DETAIL_PAGE_TABS[0].id
        const rawHash = window.location.hash || ""
        const hashWithoutQuery = normalizeTaskTabHash(rawHash)
        const taskIdFromHash = getTaskIdFromHash(rawHash)
        if (hashWithoutQuery && INCIDENT_DETAIL_PAGE_TABS.map(item => item.id).includes(hashWithoutQuery)) {
            this.setState({ tab: hashWithoutQuery })
            if (taskIdFromHash && !new URLSearchParams(window.location.search).get("task_id")) {
                this.props.navigate({ search: `?task_id=${taskIdFromHash}`, hash: hashWithoutQuery }, { replace: true })
            }
        } else {
            window.location.hash = defaultTab
            this.setState({ tab: defaultTab })
        }
    }

    componentDidUpdate(_, prevState) {
        if (this.state.tab !== prevState.tab) {
            this.props.navigate({ search: window.location.search, hash: this.state.tab })
        }
    }

    render() {
        if (!this.props.incident && this.props.incidentLoading) {
            return <Progress animated color="info" value="100" />
        }

        return (
            <div className="incident-detail-container">
                <IncidentDetailHeader incident={this.props.incident} />
                {this.props.incident &&
                    <div className="incident-detail">
                        <Nav tabs>
                            {INCIDENT_DETAIL_PAGE_TABS.map(item =>
                                <NavItem key={item.id} className={this.state.tab === item.id ? "active" : "inactive"}>
                                    <NavLink className={this.state.tab === item.id ? "active" : "inactive"} onClick={() => this.toggleTab(item.id)}>
                                        {this.state.tab !== "#claims" && item.id === "#claims" && (this.props.incident?.liabilityClaimExists || this.props.incident?.subroClaimExists) ?
                                            <span style={{ color: "#dc3545" }}>{item.name}</span> :
                                            <>
                                                {(item.id === "#related" && this.props.incident.vinRelatedIncidentCount > 0) && (
                                                    <>
                                                        <i className="fa fa-car incident-tab-icon-related" id="relatedVinIndicator" aria-hidden="true" />
                                                        &nbsp;
                                                        <UncontrolledTooltip target="relatedVinIndicator">
                                                            {this.props.incident.vinRelatedIncidentCount} related incident{this.props.incident.vinRelatedIncidentCount === 1 ? "" : "s"} on the same day involving the other vehicle(s) by VIN
                                                        </UncontrolledTooltip>
                                                    </>
                                                )}
                                                {item.id === "#related" ? (
                                                    <span>
                                                        <span className={this.props.incident.vinRelatedIncidentCount > 0 ? "incident-tab-related-word" : undefined}>{item.name.split("/")[0]}</span>
                                                        {item.name.includes("/") && (
                                                            <>/<span className={this.props.incident.unarchivedRelatedIncidentCount > 0 ? "incident-tab-duplicate-word" : undefined}>{item.name.split("/").slice(1).join("/")}</span></>
                                                        )}
                                                    </span>
                                                ) : (
                                                    <span style={{ color: (item.id === "#tasks" && this.props.incident.openTaskCount > 0) ? "#dc3545" : "" }}>
                                                        {item.name}
                                                    </span>
                                                )}
                                                {(this.props.incident.openTaskCount > 0 && item.id === "#tasks") && (
                                                    <span className='pending-task-count' id={"pendingTasks"}>
                                                        {this.props.incident.openTaskCount}
                                                        <UncontrolledTooltip target={"pendingTasks"}>Pending Tasks</UncontrolledTooltip>
                                                    </span>
                                                )}
                                                {(item.id === "#related" && this.props.incident.unarchivedRelatedIncidentCount > 0) && (
                                                    <>
                                                        &nbsp;
                                                        <i className="fa fa-clone incident-tab-icon-duplicate" id="relatedDuplicatesIndicator" aria-hidden="true" />
                                                        <UncontrolledTooltip target="relatedDuplicatesIndicator">
                                                            {this.props.incident.unarchivedRelatedIncidentCount} unarchived duplicate incident{this.props.incident.unarchivedRelatedIncidentCount === 1 ? "" : "s"} for this car on the same day
                                                        </UncontrolledTooltip>
                                                    </>
                                                )}
                                            </>
                                        }
                                    </NavLink>
                                </NavItem>
                            )}
                        </Nav>
                        <TabContent activeTab={this.state.tab}>
                            {this.state.tab === "#overview" &&
                                <TabPane tabId="#overview">
                                    <OverviewTab currentUser={this.props.currentUser} id={this.props.incident.id} toggleTab={(id) => this.toggleTab(id)} refetchQuery={this.props.refetchQuery} />
                                </TabPane>
                            }
                            {this.state.tab === "#documents" &&
                                <TabPane tabId="#documents">
                                    <IncidentDocumentsTab loading={this.props.incidentLoading} id={this.props.incident.id} refetchQuery={this.props.refetchQuery} viewType="incident" category="INCIDENT" />
                                </TabPane>
                            }
                            {this.state.tab === "#parties" &&
                                <TabPane tabId="#parties">
                                    {this.props.hasPermissions?.includes("view_incidentparty") ?
                                        <PartiesTabContainer loading={this.props.incidentLoading} id={this.props.incident.id} refetchQuery={this.props.refetchQuery} /> :
                                        <Alert color="danger" className="mt-4">You do not have permission to view parties involved in this incident.</Alert>
                                    }
                                </TabPane>
                            }
                            {this.state.tab === "#claims" &&
                                <TabPane tabId="#claims">
                                    <ClaimsTab loading={this.props.incidentLoading} id={this.props.incident.id} refetchQuery={this.props.refetchQuery} />
                                </TabPane>
                            }
                            {this.state.tab === "#inspection" &&
                                <TabPane tabId="#inspection">
                                    <InspectionTab id={this.props.incident?.carCondition?.id} viewType="incidents" incident={this.props.incident} refetchQuery={this.props.refetchQuery} />
                                </TabPane>
                            }
                            {this.state.tab === "#dashcam" &&
                                <TabPane tabId="#dashcam">
                                    <DashcamTab
                                        carId={this.props.incident.car.id}
                                        rentalId={this.props.incident?.rental?.id || null}
                                        incidentDate={this.props.incident?.incidentDate || null}
                                    />
                                </TabPane>
                            }
                            {this.state.tab === "#history" &&
                                <HistoryList
                                    subject={this.props.incident?.pk ? `Incident #${this.props.incident.pk}` : null}
                                    objectIds={Array.from(new Set([
                                        this.props.incident?.id,
                                        // ...(this.props.incident?.subrogationclaimSet?.edges?.map(({ node }) => node?.id).filter(Boolean) || []),
                                        // ...(this.props.incident?.liabilityclaimSet?.edges?.map(({ node }) => node?.id).filter(Boolean) || []),
                                        // ...(this.props.incident?.incidentpartySet?.edges?.map(({ node }) => node?.id).filter(Boolean) || []),
                                        ...(this.props.incident?.incidentdocumentSet?.edges?.map(({ node }) => node?.id).filter(Boolean) || []),
                                    ].filter(Boolean)))}
                                    emptyText="No history available"
                                />
                            }
                            {this.state.tab === "#tasks" &&
                                <TabPane tabId="#tasks">
                                    <TasksTab incidentId={this.props.incident?.id} />
                                </TabPane>
                            }
                            {this.state.tab === "#related" &&
                                <TabPane tabId="#related">
                                    <RelatedIncidentsTab
                                        currentUser={this.props.currentUser}
                                        carId={this.props.incident?.car?.id}
                                        incidentDate={this.props.incident?.incidentDate || null}
                                        duplicatesCount={this.props.incident?.unarchivedRelatedIncidentCount}
                                        relatedCount={this.props.incident?.vinRelatedIncidentCount}
                                        excludeIncidentIds={this.props.incident?.id ? [this.props.incident.id] : []}
                                        otherVehicleVins={Array.from(new Set(
                                            (this.props.incident?.incidentpartySet?.edges || [])
                                                .map(({ node }) => node)
                                                .filter((node) => node && !node.isDefault && node.partyType === "VEHICLE")
                                                .flatMap((node) => (node.vehicles?.edges || []).map((v) => v.node?.vin))
                                                .filter(Boolean)
                                        ))}
                                        currentIncident={{
                                            id: this.props.incident?.id,
                                            pk: this.props.incident?.pk,
                                            title: this.props.incident?.title,
                                            incidentDate: this.props.incident?.incidentDate || null,
                                        }}
                                    />
                                </TabPane>
                            }
                        </TabContent>
                    </div>}
            </div >
        )
    }
}

export default graphql(IncidentDetailQuery, {
    options: (props) => ({
        variables: { incidentId: props && props.params ? props.params.id : null },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { incident, loading, refetch, variables } }) => ({
        incident,
        incidentLoading: loading,
        variables,
        refetchQuery: () => {
            return refetch({
                query: IncidentDetailQuery,
                variables: {
                    ...variables,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { incident: fetchMoreResult.incident }
                },
            })
        },
    }),
})(
    graphql(HasPermissionsQuery, {
        options: () => ({
            variables: { userPermissions: ["view_incidentparty"] },
        }),
        props: ({ data: { hasPermissions, variables } }) => ({
            hasPermissions,
            variables,
        }),
    })(withApolloClient(IncidentDetailContainer)))
